<template>
  <div name="popup-import-xls" class="import-xls">
    <div class="import-box">
      <div class="minor-btn-active" data-toggle="modal" data-target="#popup-import-xls" ><i class="space fa fa-cloud-upload"></i>Import EXCEL</div>
    </div>
    <div id="popup-import-xls" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content clearfix">
          <div class="modal-header header-popup">
            <button type="button" class="close" @click="callClose()" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{importData}}</h4>
          </div>
          <div class="modal-body clearfix">
            <input  v-show="false"
                    id="fileExcel"
                    name="file-excel"
                    type="file"
                    accept=".xlsx,.xls,.xml,.csv"
                    @change="_change"
                    ref="browseFile" >
            <!-- .xlsx,.xlsb,.xlsm,.xls,.xml,.csv,.txt,.ods,.fods,.uos,.sylk,.dif,.dbf,.prn,.qpw,.123,.wb*,.wq*,.html,.htm -->

            <div class="panel-upload-btn">
              <label class="upload-label">{{fileName}}</label>
              <button type="button"
                      class="btn bg-color-skin"
                      @click="$refs.browseFile.click()"><i class="fa fa-check-circle" ></i>{{ labelsButton['chooseFile'] }}</button>
              <label class="upload-label">worksheet</label>
              <input type="text" id="worksheet" name="worksheet" class="input-worksheet" v-model="sheet" />
              <button type="button"
                      class="btn bg-color-skin"
                      @click="upload()"><i class="fa fa-check-circle"></i>{{ labelsButton['load'] }}</button>
              <div class="sample-download">
                <a :href="baseURL + fileSample" download target="_blank" @click.stop>(Download Sample)</a>
              </div>
            </div>
            <hrms-table  :columns="columnsF"
                         :data="dataImp"
                         :searchDisp="true" />

            <div class="panel-summary clearfix">
              <div class="col-sm-9 col-sm-push-3">
                <div class="form-horizontal">

                  <div class="form-group">
                    <label class="col-sm-3 control-label">{{totalRows}}</label>
                    <div class="col-sm-6">
                      <input type="input" readonly="readonly" class="form-control" :value="dataImp.rows.length">
                    </div>
                    <label class="col-sm-3 control-label" style="text-align: left">{{record}}</label>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-3 control-label">{{completeRows}}</label>
                    <div class="col-sm-6">
                      <input type="input" readonly="readonly" class="form-control" :value="countSuccess">
                    </div>
                    <label class="col-sm-3 control-label" style="text-align: left">{{record}}</label>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-3 control-label">{{errorRows}}</label>
                    <div class="col-sm-6">
                      <input type="input" readonly="readonly" class="form-control" :value="countError">
                    </div>
                    <label class="col-sm-3 control-label" style="text-align: left">{{record}}</label>
                  </div>

                </div>
              </div>
              <div class="col-sm-3 col-sm-pull-9 btn-save">
                <button type="button" class="btn bg-color-skin" @click="callSave()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
              </div>
            </div>
            <div class="col-md-12 form-horizontal hidden">
              <div class="form-group">
                <div class="col-sm-2"/>
                <label class="col-sm-3 control-label">{{totalRows}}</label>
                <div class="col-sm-2">
                  <input type="input" readonly="readonly" class="form-control" :value="dataImp.rows.length">
                </div>
                <label class="col-sm-3 control-label" style="text-align: left">{{record}}</label>
              </div>

              <div class="form-group">
                <div class="col-sm-2">
                  <button type="button" class="btn bg-color-skin" @click="callSave()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
                </div>
                <label class="col-sm-3 control-label">{{completeRows}}</label>
                <div class="col-sm-2">
                  <input type="input" readonly="readonly" class="form-control" :value="countSuccess">
                </div>
                <label class="col-sm-3 control-label" style="text-align: left">{{record}}</label>
              </div>

              <div class="form-group">
                <div class="col-sm-2"/>
                <label class="col-sm-3 control-label">{{errorRows}}</label>
                <div class="col-sm-2">
                  <input type="input" readonly="readonly" class="form-control" :value="countError">
                </div>
                <label class="col-sm-3 control-label" style="text-align: left">{{record}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import Dropzone from 'vue2-dropzone'
import env from 'src/../env.js'
const makeCols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({name: XLSX.utils.encode_col(i), key: i}))

export default {
  name: 'popup-import-xls',
  props: [ 'labels', 'labelsButton', 'postImport', 'resultImport', 'searchIndex', 'fileSample' ],
  data: function () {
    return {
      url: 'xxx',
      impEvent: '',
      fileName: '',
      sheet: 1,
      files: {},
      dataImp: {
        total: 0,
        rows: []
      },
      columnsF: [
        {
          key: 'desc_status',
          name: 'Status'
        },
        {
          key: 'remark',
          name: 'Remark'
        }
      ],
      importData: constLabels('importData'),
      totalRows: constLabels('totalRows'),
      completeRows: constLabels('completeRows'),
      errorRows: constLabels('errorRows'),
      record: constLabels('record'),
      chooseFile: constLabels('chooseFile'),
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'Sample_Import/'
    }
  },
  computed: {
    countError () {
      let filtered = this.dataImp.rows.filter(function (element) {
        return element['flg_status'] === 'E'
      })
      return filtered.length
    },
    countSuccess () {
      let filtered = this.dataImp.rows.filter(function (element) {
        return element['flg_status'] === 'S'
      })
      return filtered.length
    }
  },
  watch: {
    'resultImport' () {
      this.dataImp = this.resultImport
    }
  },
  methods: {
    _change (event) {
      this.files = event.target.files
      this.fileName = event.target.files[0].name
    },
    _file (file) {
      /* Boilerplate to set up FileReader */
      const reader = new window.FileReader()
      reader.onload = (event) => {
        const bstr = event.target.result
        const workbook = XLSX.read(bstr, {type: 'binary'})
        const worksheet = workbook.Sheets[workbook.SheetNames[this.sheet - 1]]
        const header1 = XLSX.utils.sheet_to_json(worksheet, {header: 1})
        const data = XLSX.utils.sheet_to_json(worksheet, {header: header1[0], defval: ''})
        this.data = data.shift()
        this.cols = makeCols(worksheet['!ref'])

        // result
        this.columnsF = this.mapExcelHeaders(header1[0]) // console.info(this.mapExcelHeaders(header1[0]))
        this.dataImp.rows = this.mapExcelRows(data)
      }
      reader.readAsBinaryString(file)
    },
    upload () {
      if (this.files && this.files[0] && this.fileName) this._file(this.files[0])
    },
    mapExcelHeaders (dataHeader) {
      let n = 0
      let ret = [
        {
          key: 'desc_status',
          name: 'Status'
        },
        {
          key: 'remark',
          name: 'Remark'
        }
      ]
      for (let i = 0; i < dataHeader.length; i++) {
        n++
        ret.push({key: 'item' + n, name: dataHeader[i]})
      }
      return ret
      // return descriptions.map(function (x) {
      //   n++
      //   return {
      //      'item' + n,
      //     name: x
      //   }
      // })
    },
    mapExcelRows (dataRow) {
      let ret = []
      for (let i = 0; i < dataRow.length; i++) {
        let data = {
          status: '',
          remark: ''
        }
        let n = 0
        for (let key in dataRow[i]) {
          n++
          let value = dataRow[i][key]
          data['item' + n] = value
        }
        ret.push(data)
      }
      return ret
      // return descriptions.map(function (x) {
      //   n = 0
      //   for (let key in x) {
      //     if (x.hasOwnProperty(key)) {
      //       n++
      //       let value = x[key]
      //       data['item' + n] = value
      //     }
      //   }
      //   return data
      // })
    },
    callSave () {
      let _this = this
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (_this.fileName) {
          if (_this.dataImp.rows.length > 0) {
            if (isConfirm) {
              _this.postImport({ searchIndex: _this.searchIndex, dataHeader: _this.columnsF, dataRowsHasFlg: _this.dataImp.rows })
            }
          } else {
            swal({
              title: '', text: constLabels('HR8844'), html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        } else {
          swal({
            title: '', text: constLabels('HR8842'), html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        }
      })
    },
    callClose () {
      this.dataImp = {
        total: 0,
        rows: []
      }
      this.columnsF = [
        {
          key: 'desc_status',
          name: 'Status'
        },
        {
          key: 'remark',
          name: 'Remark'
        }
      ]
      this.fileName = ''
      document.getElementById('fileExcel').value = ''
    }
  },
  components: {
    Dropzone
  }
}
</script>

<style lang="scss">
.import-xls {
  .modal-content{
    width: 100%; /* respsonsive width */
    // margin-left:-40%; /* width/2) */
  }
  .import-box {
    float: right;
    margin: 10px 10px 10px 10px;

    @media (max-width: 768px) {
      float: left;
    }

    .minor-btn-active {
      height: 25px;
      border-radius: 2px;
      padding: 4px 8px;
      background: #7d7d7d;
      box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
      cursor: pointer;
      color: #FFF;

      &:hover {
        box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);
        color: #FFF;
      }
    }

    .minor-btn-inactive {
      height: 25px;
      border-radius: 2px;
      padding: 4px 8px;
      background: #E0E0E0;
      box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
      cursor: not-allowed;
      color: #FFF;

      &:hover {
        color: #FFF;
      }
    }

    .space {
      margin-right: 8px;
    }

    .minor-btn-inactive {
      height: 25px;
      border-radius: 2px;
      padding: 4px 8px;
      background: #E0E0E0;
      box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
      cursor: not-allowed;
      color: #FFF;

      &:hover {
        color: #FFF;
      }
    }
  }
  .panel-upload-btn {
    float: right;
    .upload-label {
      margin: 0px 5px 0px 5px;
    }
    .input-worksheet {
      margin-right: 5px;
      width: 70px;
    }
    @media (max-width: 480px) {
      float: none;
      text-align: center;
    }
    .sample-download {
      margin-left: 5px;
      a:link {
        color: #2795d4;
      }
      a:hover {
        color: red;
      }
    }
  }
  .panel-summary {
    border: 1px solid #ccc;
    margin: 10px;
    padding: 10px 0;
    .btn-save {
      margin-top: 50px;
      @media (max-width: 480px) {
        margin-top: 10px;
      }
    }
  }

  table {
    th {
      min-width: 100px;
      white-space: nowrap;
    }
  }
}

</style>



// WEBPACK FOOTER //
// xlsImporter.vue?c462e522